import { overheadJob } from './portalModel';
import type { PortalJob, PortalRole } from './portalTypes';

/**
 * Employee Time Portal — what the employee's ROLE allows (P-TAS-20 Phase 3). One rule for
 * Today, the job picker and My Timesheet's day detail, mirroring mobile
 * (MobileApp types/clockHourlyV2.ts getRoleFilteredPayloadKinds): the job kinds need
 * Role.RecordHoursJob, non-job time is Role.RecordHoursOther / the non-job account code.
 * The tenant config's jobCosting block is the company switch plus the non-job account
 * code; it never turns job costing on for a role that doesn't have it.
 */

export interface JobCostingConfig {
  enabled: boolean;
  hourlyOtherOneAccountCodeSection: { enabled: boolean; accountCodeID: number };
}

export interface PortalJobMode {
  /** Show the "Working on" card / job picker: the company switch AND Role.RecordHoursJob. */
  jobCosting: boolean;
  /** The non-job ("Office / Overhead") charge every non-job punch carries. */
  nonJob: PortalJob;
}

export function portalJobMode(cfg: JobCostingConfig | null | undefined, role: PortalRole | null | undefined): PortalJobMode {
  const section = cfg?.hourlyOtherOneAccountCodeSection;
  return {
    jobCosting: !!cfg?.enabled && !!role?.recordHoursJob,
    nonJob: overheadJob(section?.enabled ? section.accountCodeID : null, role?.defaultAccountCodeID ?? null),
  };
}

export const MOBILE_ONLY_SUBMIT_MESSAGE =
  'This week needs to be submitted from the mobile app — your role records claims (tasks, operational tasks or warranty work) the web portal can\'t include.';

/**
 * Claims the portal can't read (piece tasks, operational tasks, customer-service / warranty
 * claims) would be left out of a portal submit, so a role that records any of them submits
 * from the mobile app. Returns the reason, or null when the portal may submit.
 */
export function portalSubmitBlockedByRole(role: PortalRole | null | undefined): string | null {
  if (role?.recordTasks || role?.recordOperationalTask || role?.recordCustomerServiceWarranty) return MOBILE_ONLY_SUBMIT_MESSAGE;
  return null;
}
